import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { ITheme } from "../Layout/themes";
import { Modal, Fade, useMediaQuery, Drawer } from "@material-ui/core";
import { connect } from "react-redux";
import { IStoreState } from "../Store";
import { Dispatch } from "redux";
import { closeHowItWorksModal } from "./actions";
import { ModalContent } from "./ModalContent";
import { useTheme } from "@material-ui/styles";

const useStyles = makeStyles(({ palette, typography, breakpoints }: ITheme) => {
  return createStyles({
    backdropRoot: {
      backgroundColor: "rgba(0,0,0,0.8)"
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    contentContainer: {
      "&:focus": {
        outline: "none"
      }
    }
  });
});

export const HowItWorksModalComponent = ({
  modaleOpen,
  closeModal
}: {
  modaleOpen: boolean;
  closeModal: () => void;
}) => {
  const classes = useStyles({});
  const theme = useTheme<ITheme>();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  if (matches) {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modaleOpen}
        onClose={closeModal}
        style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
        closeAfterTransition
      >
        <Fade in={modaleOpen}>
          <div className={classes.contentContainer} data-testid="modalContent">
            <ModalContent closeModal={closeModal} />
          </div>
        </Fade>
      </Modal>
    );
  }

  return (
    <Drawer
      anchor="right"
      open={modaleOpen}
      onClose={closeModal}
      BackdropProps={{
        classes: {
          root: classes.backdropRoot
        }
      }}
    >
      <div className={classes.contentContainer} data-testid="drawerContent">
        <ModalContent closeModal={closeModal} />
      </div>
    </Drawer>
  );
};

const mapStateToProps = (state: IStoreState) => {
  return {
    modaleOpen: state.howItWorksModal.open
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    closeModal: () => dispatch(closeHowItWorksModal())
  };
};

export const HowItWorksModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(HowItWorksModalComponent);
